import { Injectable, inject } from '@angular/core';
import { AlertController } from '@ionic/angular/standalone';
import { PUBLIC_MARKETING_RUNTIME_CONFIG } from '../tokens/public-marketing-runtime.token';
import { PublicLeadSubmissionError } from './public-lead-submission.service';

@Injectable({ providedIn: 'root' })
export class PublicLeadSubmissionErrorDialogService {
  private readonly alerts = inject(AlertController);
  private readonly marketing = inject(PUBLIC_MARKETING_RUNTIME_CONFIG);

  async show(err: unknown): Promise<void> {
    const parts: string[] = [];
    parts.push('--- Context ---');
    parts.push(`Time (ISO): ${new Date().toISOString()}`);
    if (typeof navigator !== 'undefined') {
      parts.push(`Online: ${navigator.onLine}`);
      parts.push(`User-Agent: ${navigator.userAgent}`);
    }
    if (typeof location !== 'undefined') {
      parts.push(`Page URL: ${location.href}`);
    }
    parts.push(`Environment: ${this.marketing.environmentName}`);
    parts.push(`Production build: ${this.marketing.production}`);
    parts.push(`apiUrl: ${this.marketing.apiUrl?.trim() || '(not set)'}`);
    parts.push('');

    if (err instanceof PublicLeadSubmissionError && err.requestDiagnostics) {
      parts.push('--- Request / response ---');
      parts.push(err.requestDiagnostics);
      parts.push('');
    }

    parts.push('--- Error ---');
    if (err instanceof Error) {
      parts.push(`Name: ${err.name}`);
      parts.push(`Message: ${err.message}`);
      const c = err.cause;
      if (c !== undefined && c !== null) {
        parts.push(`Cause: ${c instanceof Error ? `${c.name}: ${c.message}` : String(c)}`);
      }
      if (err.stack) {
        parts.push('');
        parts.push('Stack:');
        parts.push(err.stack);
      }
    } else {
      parts.push(String(err));
    }

    const full = parts.join('\n');
    const short = err instanceof Error ? err.message : 'Something went wrong. Please try again.';
    const subHeader = short.length > 200 ? `${short.slice(0, 197)}...` : short;

    const alert = await this.alerts.create({
      header: 'Could not submit',
      subHeader,
      message: full,
      cssClass: 'public-lead-error-alert',
      buttons: [
        {
          text: 'Copy details',
          handler: () => {
            void navigator.clipboard?.writeText(full).catch(() => undefined);
            return true;
          },
        },
        { text: 'OK', role: 'cancel' },
      ],
    });

    await alert.present();
  }
}
